import React from 'react';
import { LockClosedIcon } from '@heroicons/react/20/solid';
import { stocksMetadata } from '../../../redux/reducers/data';
import store from '../../../store';
import i18n from '../../../i18n';

// INPUT transformations

// used to put quote object attributes in the exact order expected by table and grid layouts
export function categoryOrderedObject(account = null) {
  //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
  return function stocksOrderedObjectInnerFunc(quote) {
    // this has to exactly follow the column order laid out by gridLayout
    return {
      displaySymbol: stocksMetadata(store.getState()).displaySymbolByAssetId[quote.assetId],
      date: quote.date,
      source: quote.source,
      quoteBaseCurrency: quote.quoteBaseCurrency,
      currency: quote.currency,
      quote: quote.quote,
    };
  };
}

// applies category-related final changes before sending to Grid
// add displaySymbol based on figi
export function applyCategorySpecificChanges(_quotes, account = null) {
  return _quotes.map(categoryOrderedObject());
}

// provide sources for custom dropdown 'displaySymbol"
export function getCustomDropdownSources() {
  // return { displaySymbol: Object.entries(stocksMetadata(store.getState()).displayNameByDisplaySymbol).map(([key, value]) => ({ id: key, name: value })) };
  return { displaySymbol: Object.keys(stocksMetadata(store.getState()).displayNameByDisplaySymbol) };
}

// getCustomOnChange is not needed, because we only need to display displaySymbols for now
// when displaySymbol changes, reapply displayName from existing transactions (if any)
// export function getCustomOnChange() {
//   return function getCustomOnChangeInner(instance, cell, x, y, value) {
//     // if current column is 'displaySymbol'
//     if (instance && instance.jspreadsheet.options.columns[x].name === 'displaySymbol') {
//       // find a column 'displayName' and get the displayName based on displaySymbol's 'value' from stocksMetadata
//       const displayNameColumnIndex = instance.jspreadsheet.options.columns.findIndex((column) => column.name === 'displayName');
//       if (displayNameColumnIndex !== -1) {
//         const displayName = stocksMetadata(store.getState()).displayNameByDisplaySymbol[value] || '';
//         instance.jspreadsheet.setValueFromCoords(displayNameColumnIndex, y, displayName, false);
//       }
//     }
//   };
// }

// OUTPUT transformations

// used inside of .map
// performs category - specific transformations after standard transformations of Grid output
// seqeunce of properties is no longer important
// this happens already after items with inputFlag = 'delete' have been added, so just take care of 'put'
export function outputTransformCategoryQuotes(account = null) {
  //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
  return function outputTransformStockQuotesInnerFunc(item) {
    return {
      ...item,
      source: item.source || 'manual',
      importFlag: item.importFlag || 'put',
      assetId: stocksMetadata(store.getState()).assetIdByDisplaySymbol[item.displaySymbol], // in case customer deleted the existing mapping and is re-using the same row
    };
  };
}

export function EmptyStateMessage() {
  const h = React.createElement;

  return (
    h(
      'div',
      { className: 'bg-white py-8 w-full self-start' },
      h(
        'div',
        { className: 'mx-auto max-w-7xl px-6 lg:px-8' },
        h(
          'div',
          { className: 'mx-auto max-w-3xl lg:text-center' },
          h('h2', { className: 'text-base font-semibold leading-8 tracking-wide text-brandBlue-500 uppercase' }, i18n.t('accountDetails:quotesEmptyStocks.heading')),
          h('p', { className: 'mt-2 text-3xl sm:text-4xl font-bold text-gray-900' }, i18n.t('accountDetails:quotesEmptyStocks.subheading')),
          h('p', { className: 'mt-4 text-base leading-7 text-gray-600' }, i18n.t('accountDetails:quotesEmptyStocks.intro')),
        ),
        h(
          'div',
          { className: 'mx-auto mt-8 max-w-2xl sm:mt-20' },
          h(
            'div',
            { className: 'rounded-2xl border border-gray-200 bg-gray-50 p-6 sm:p-8' },
            h(
              'div',
              { className: 'flex items-start gap-x-3' },
              h(LockClosedIcon, { className: 'h-5 w-5 flex-none text-brandBlue-500 mt-0.5', 'aria-hidden': 'true' }),
              h(
                'div',
                null,
                h('p', { className: 'text-base font-semibold leading-7 text-gray-900' }, i18n.t('accountDetails:quotesEmptyStocks.featureTitle')),
                h('p', { className: 'mt-2 text-base leading-6 text-gray-600' }, i18n.t('accountDetails:quotesEmptyStocksManualOnly')),
              ),
            ),
          ),
        ),
      ),
    )
  );
}
